export default __webpack_public_path__ + "static/media/dark-blue-ball.e739d4ae.svg";